/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { Video } from "../../components/Video";
import googlePlayIcon from "../../assets/google-play-icon.png";
import appStoreIcon from "../../assets/app-store-icon.png";
import { WelcomeAboardPageProps } from "./interfaces";
import { welcomeAboardPageStyle } from "./styles";
import smileyLogo from "../../assets/smiley-icon.svg";
import { useIsMobile, useIsTab } from "../../hooks/useIsMobile";
import useSTR from "react-str";
import { getData } from "../../utils/fetchers";
import { URL } from "../../API/urlEndpoints";
import { Skeleton } from "antd";
import { ErrorComponent } from "../../molecules/ErrorComponent";
import { useUserContext } from "../../hooks/cookieHooks";
import {
  color,
  getFinalOnboardText,
  getonBoardingText,
} from "../../constants/commons";
import { Profession } from "../../commons/interfaces";
import * as _ from "lodash";
import { singleSectionStyles } from "../../commons/styles";

export const WelcomeAboardPage: React.FunctionComponent<WelcomeAboardPageProps> = (
  props
) => {
  // State to maintain the fetched media Objects from the GET API call
  const [mediaListFromAPI, setMediaListFromAPI] = React.useState<Array<any>>();

  // State to maintain the fetched appStore link from the GET API call
  const [appStoreLink, setAppStoreLink] = React.useState<string>();
  // State to maintain the fetched play store link from the GET API call
  const [playStoreLink, setPlayStoreLink] = React.useState<string>();
  const isMobileView = useIsMobile();
  const isTabView = useIsTab();
  // Calling the SSO Hook to retrieve user information of the logged in user
  const user = useUserContext();
  // [GET] API on Page load
  const [
    ,
    {
      result: getMediaList,
      revalidator: refetchMediaList,
      loading,
      error: errorMediaList,
    },
  ] = useSTR(getData);

  React.useEffect(() => {
    refetchMediaList(
      `${URL.getHowtoUseMediaList(user.memberships[0].context as Profession)}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Hook which sets the state when the media files are recieved from the API
  React.useEffect(() => {
    if (getMediaList) {
      const { appStoreLink, playStoreLink, howToUse } = getMediaList;
      howToUse && setMediaListFromAPI(howToUse);
      appStoreLink &&
        _.keys(appStoreLink).length > 0 &&
        setAppStoreLink(appStoreLink);
      playStoreLink &&
        _.keys(playStoreLink).length > 0 &&
        setPlayStoreLink(playStoreLink);
    }
  }, [getMediaList]);

  const howToUseComponent = React.useCallback(() => {
    if (loading) {
      return <Skeleton />;
    } else {
      return (
        mediaListFromAPI &&
        Object.keys(mediaListFromAPI).length > 0 &&
        mediaListFromAPI.map((data: any, key: number) => {
          return (
            <div className="d-flex flex-column m-2" key={key}>
              <div className="video-container">
                <Video videoUrl={data.mediaFileUrl} />
              </div>
              <div className="video-description-text">{data.mediatitle}</div>
            </div>
          );
        })
      );
    }
  }, [mediaListFromAPI, loading]);

  return (
    <span css={welcomeAboardPageStyle}>
      <div className="container-fluid p-0 m-0 background-finalscreen-style">
        <div className="container">
          <div
            className={`d-flex justify-content-center flex-column align-items-center ${
              isMobileView || isTabView
                ? "welcome-aboard-padding-style"
                : "py-5"
            }`}
          >
            <div className="my-2">
              <img src={smileyLogo} alt="" width="100%" height="100%" />
            </div>
            <div className="title">Wohoo! Registration Completed!</div>
            <div className="description-style">
              {!!getonBoardingText(user.memberships[0].context as Profession) &&
                getonBoardingText(user.memberships[0].context as Profession)}
              {!!getFinalOnboardText(
                user.memberships[0].context as Profession
              ) &&
                getFinalOnboardText(user.memberships[0].context as Profession)}
            </div>
            {playStoreLink && appStoreLink && (
              <div className="d-flex mt-5 mb-3">
                {playStoreLink && (
                  <a
                    className={`mx-2 ${isMobileView ? "" : "text-right"}`}
                    href={playStoreLink}
                  >
                    <img
                      src={googlePlayIcon}
                      alt=""
                      width={`${isMobileView ? "100%" : "65%"} `}
                    />
                  </a>
                )}
                {appStoreLink && (
                  <a
                    className={`mx-2 ${isMobileView ? "" : "text-left"}`}
                    href={appStoreLink}
                  >
                    <img
                      src={appStoreIcon}
                      alt=""
                      width={`${isMobileView ? "100%" : "65%"} `}
                    />
                  </a>
                )}
              </div>
            )}
          </div>
          {errorMediaList && <ErrorComponent errorObj={errorMediaList} />}
          {/* {mediaListFromAPI && mediaListFromAPI.length && (
            <div className="py-3 ">
              <h4>How to use</h4>
              <div className="d-flex overflow-auto">{howToUseComponent()}</div>
            </div>
          )} */}
        </div>
      </div>
      {mediaListFromAPI && !!mediaListFromAPI.length && (
        <div
          className={`single-section mt-0 mb-0`}
          css={singleSectionStyles(color.whitishGray)}
        >
          <h4>How to use</h4>
          <div className="d-flex overflow-auto">{howToUseComponent()}</div>
        </div>
      )}
    </span>
  );
};
